import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PageService } from '@services/index';
import { NotificationState } from '@models/index';

@Component({
  selector: 'aff-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, OnDestroy {
  
  notification: NotificationState;
  notification$: Observable<NotificationState>;
  private unsubscribe$ = new Subject<void>();

  constructor(private pageService: PageService) {
    this.notification$ = pageService.getNotificationSelector();
   }

  ngOnInit(): void {
    this.notification$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(notification => {
        this.notification = { ...notification };
        if (notification.show) {
          setTimeout(() => {
            this.pageService.onNotificationToggle({ ...this.notification, show: false });
          }, 2000);
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
